import React from 'react';
import MothersDayCover from '../assets/MothersDayCover_thumb.jpg';
import BurgundyCover from '../assets/BurgFullWrapJ_thumb.jpg';
import GoldLinenCover from '../assets/GoldLinen_thumb.jpg';
import CharcoalGoldCover from '../assets/CharcoalGold_thumb.jpg';
import FloralWrapFrontPanel from '../assets/floral_wrap_front_panel_thumb.jpg';
import BurgWrapFrontPanel from '../assets/burg_wrap_front_panel_thumb.jpg';
import MustardPlumCover from '../assets/floral_final_fullwrap_thumb.jpg';

/**
 * CoverThumbnail — REVEAL-001 C4 (Q1). A small front-face image of the book's chosen cover, so the
 * State-3 "kept" card shows the user's ACTUAL cover ("that's my book!") rather than a generic spine.
 * Maps coverDesign → the same thumbnail assets BookBuilder's cover preview uses (front-panel crops for
 * the full-wrap designs, so we show only what prints). Default = Plum Blossom / mustardplum, per
 * DECISION_REGISTER COVER-DEFAULT-PLUM-BLOSSOM. (My Book's book-card retrofit to this component is
 * punch-listed — the recognition moment is real in the reveal this build.)
 */
const COVER_THUMBS = {
  burgundy: BurgundyCover,
  mothersday: MothersDayCover,
  linen: GoldLinenCover,
  charcoalgold: CharcoalGoldCover,
  charcoal: CharcoalGoldCover,
  floralwrap: FloralWrapFrontPanel,
  burgwrap: BurgWrapFrontPanel,
  mustardplum: MustardPlumCover,
};

export default function CoverThumbnail({ coverDesign, width = 46, height = 62, alt = '' }) {
  const src = COVER_THUMBS[coverDesign] || MustardPlumCover;
  return (
    <div style={{
      width, height, borderRadius: 3, overflow: 'hidden', flex: 'none',
      boxShadow: 'inset -3px 0 4px rgba(0,0,0,.22), 0 2px 8px rgba(60,47,30,.20)', background: '#8a6420',
    }}>
      <img src={src} alt={alt} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
    </div>
  );
}
